class sizeGuide {
  constructor(parent) {
    if(!parent) {
      return;
    }
    this.parent = parent

    this.init();
  }

  clickEvent = () => {
    let parent = this.parent
    document.addEventListener('click',(e)=>{
      if(e.target.classList.contains('custom-radio') && e.target.closest('.size-units-js')){
        let value = e.target.dataset.class;
        let prt = e.target
        const tableParent = e.target.closest(".size-chart-modal-wrapper")
        const unitTables = parent.querySelectorAll(".data-table-wrapper .units-table")
        unitTables.forEach((table)=> table.classList.remove('active'))
        const unitTable = tableParent.querySelector(`.data-table-wrapper ${value}`)
        if(unitTable){
          unitTable.classList.add("active")
        }
      }else if(e.target.classList.contains('custom-radio-label') && e.target.closest('.size-units-js')){
        let parent = e.target.closest('.size-units-js')
        let input =  parent.querySelector('input');
        input.checked = true
        let labelActive =  parent.querySelector('.custom-radio-label');
        let labelActiveRe = document.querySelectorAll(".size-chart-modal-wrapper .size-units-js .custom-radio-label")
        if(labelActiveRe){
          labelActiveRe.forEach((ele)=>{
            ele.classList.remove("active")
          })
        }
        if(labelActive){
          labelActive.classList.add("active")
        }
        let value = parent.querySelector('input').dataset.class;
        const tableParent = e.target.closest(".size-chart-modal-wrapper")
        const unitTables = tableParent.querySelectorAll(".data-table-wrapper .units-table")
        unitTables.forEach((table)=> table.classList.remove('active'))
        const unitTable = tableParent.querySelector(`.data-table-wrapper ${value}`)
        if(unitTable){
          unitTable.classList.add("active")
        }
      } else if(e.target.classList.contains('size-in-text') && e.target.closest('.size-units-js')){
        let parent = e.target.closest('.size-units-js');
        let input = parent.querySelector('label')
        if(input){
          input.click()
        }
      }
    })


  }

  init = () => {
    this.clickEvent();
  }
}
new sizeGuide(qs('.size-chart-modal-wrapper'));